export const pwmBoundary = {
  "type": "GeometryCollection",
  "geometries": [
    {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [
              -70.122,
              43.7
            ],
            [
              -70.115,
              43.697
            ],
            [
              -70.099,
              43.711
            ],
            [
              -70.095,
              43.713
            ],
            [
              -70.091,
              43.712
            ],
            [
              -70.085,
              43.7
            ],
            [
              -70.096,
              43.689
            ],
            [
              -70.096,
              43.687
            ],
            [
              -70.066,
              43.673
            ],
   
            [
              -70.12,
              43.672
            ],
            [
              -70.132,
              43.684
            ],
            [
              -70.122,
              43.7
            ]
          ]
        ],
        [
          [
            [
              -70.345,
              43.647
            ],
            [
              -70.34,
              43.652
            ],
            [
              -70.344,
              43.655
            ],
            [
              -70.337,
              43.661
            ],
            [
              -70.333,
              43.662
            ],
            [
              -70.328,
              43.678
            ],
            [
              -70.329,
              43.683
            ],
            [
              -70.335,
              43.69
            ],
            [
              -70.329,
              43.692
            ],
            [
              -70.328,
              43.695
            ],
            [
              -70.329,
              43.698
            ],
            [
              -70.325,
              43.7
            ],
            [
              -70.325,
              43.702
            ],
            [
              -70.322,
              43.704
            ],
            [
              -70.323,
              43.709
            ],
            [
              -70.316,
              43.714
            ],
            [
              -70.316,
              43.717
            ],
            [
              -70.31,
              43.719
            ],
            [
              -70.308,
              43.723
            ],
            [
              -70.305,
              43.723
            ],
            [
              -70.299,
              43.719
            ],
            [
              -70.292,
              43.725
            ],
            [
              -70.286,
              43.726
            ],
            [
              -70.282,
              43.722
            ],
            [
              -70.28,
              43.722
            ],
            [
              -70.284,
              43.716
            ],
            [
              -70.278,
              43.713
            ],
            [
              -70.278,
              43.705
            ],
            [
              -70.275,
              43.704
            ],
            [
              -70.271,
              43.699
            ],
            [
              -70.266,
              43.701
            ],
            [
              -70.251,
              43.699
            ],
            [
              -70.25,
              43.694
            ],
            [
              -70.246,
              43.689
            ],
            [
              -70.218,
              43.68
            ],
            [
              -70.216,
              43.68
            ],
            [
              -70.215,
              43.684
            ],
            [
              -70.207,
              43.694
            ],
            [
              -70.199,
              43.699
            ],
            [
              -70.158,
              43.649
            ],
        
           
            [
              -70.182,
              43.623
            ],
            [
              -70.205,
              43.629
            ],
            [
              -70.213,
              43.634
            ],
            [
              -70.216,
              43.638
            ],
            [
              -70.219,
              43.652
            ],
            [
              -70.225,
              43.658
            ],
            [
              -70.228,
              43.659
            ],
            [
              -70.239,
              43.659
            ],
            [
              -70.262,
              43.643
            ],
            [
              -70.273,
              43.643
            ],
            [
              -70.28,
              43.64
            ],
            [
              -70.286,
              43.647
            ],
            [
              -70.296,
              43.648
            ],
            [
              -70.315,
              43.647
            ],
            [
              -70.313,
              43.648
            ],
            [
              -70.313,
              43.651
            ],
            [
              -70.345,
              43.647
            ]
          ]
        ]
      ]
    }
  ]
}